import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import Discord from '../../assets/images/discord.svg';
import Twitter from '../../assets/images/twitter.svg';
import Instagram from '../../assets/images/insta.svg';

import './footer.css';

const Footer = () => {
  return (
    <React.Fragment>
      <Container fluid className='footer__container'>
        <Container>
          <Row className='footer__mobi'>
            <Col xs={12} md={12} className='footer__credits'>
              Copyright © 2022 Kutee Kitty Nft.
            </Col>
          </Row>
        </Container>
      </Container>
    </React.Fragment>
  );
};

export default Footer;
